import React, { Component } from "react";
import { connect } from "react-redux";

import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { getGroups, addUserGroup, addUserGroupSuccess } from "../reducers/groupReducer";
//import { resetAllStatus } from "reducers/workspaceReducer";
import {
  getUsers,
  addNewUser,
  inviteUsers,
  inviteSpecifiedUsers,
  deleteUsers,
  addUserToGroup,
  updateUserGroups,
  graphUpdateUserGroups,
  filterUsers,
  clearToasts,
  updateUser,
} from "../reducers/userManagementReducer";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-balham.css";
import "ag-grid-community";
import "./style.css";
import _ from "lodash";
import axios from "axios";

import { toast } from "react-toastify";
import validator from "validator";
import { addTabToNav } from "../../../components/topLevelNav/reducers/topLevelNavReducer";
import { LicenseManager, SetFilterModule } from "ag-grid-enterprise";
import { ClientSideRowModelModule } from "ag-grid-community";

LicenseManager.setLicenseKey(
  "Using_this_{AG_Grid}_Enterprise_key_{AG-083969}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{TELUS_Agriculture_&_Consumer_Goods_(US,_PA,_6632)}_is_granted_a_{Single_Application}_Developer_License_for_the_application_{TABSInsight}_only_for_{1}_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_{TABSInsight}_need_to_be_licensed___{TABSInsight}_has_been_granted_a_Deployment_License_Add-on_for_{1}_Production_Environment___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{14_October_2026}____[v3]_[01]_MTc5MTkzMjQwMDAwMA==073ec8e13184eaa9da8a95a5efbcc8c5",
);

// simple function cellRenderer, just returns back the name of the group
function GroupCellRenderer() {}
GroupCellRenderer.prototype.init = function (params) {
  this.eGui = document.createElement("span");
  this.refresh(params);
};
GroupCellRenderer.prototype.refresh = function (params) {
  this.eGui.textContent = (params.value || []).filter(Boolean).map((group) => group.name).join(",");
  return true;
};
GroupCellRenderer.prototype.getGui = function () {
  return this.eGui;
};
const gridModules = [ClientSideRowModelModule, SetFilterModule];

var groupComparator = (item1, item2) => {
  const a = (typeof item1 === "string" ? item1 : item1?.[0]?.name || "").toLowerCase();
  const b = (typeof item2 === "string" ? item2 : item2?.[0]?.name || "").toLowerCase();
  return a > b ? 1 : a < b ? -1 : 0;
};

export class UserManagement extends Component {
  constructor(props) {
    super(props);
    this.unmounted = false;
    this.groupSaveInFlight = false;
    this.state = {
      selectedFile: null,
      loaded: 0,
      client: this.props.clients,
      inputValue: "",
      showAddUserModal: false,
      showDeleteConfirmModal: false,
      showAssignGroupsModal: false,
      showGroupsModal: false,
      firstName: "",
      lastName: "",
      userName: "",
      groups: [],
      groupStates: {},
      initialGroupStates: {},
      editingUsers: [],
      savingGroups: false,
      selectedUsers: [],
      invitedCheckRan: false,
      uninvited: false,
      columnDefs: [
        {
          headerName: "Username",
          field: "userName",
          sortable: true,
        },
        {
          headerName: "First Name",
          field: "firstName",
          editable: true,
          sortable: true,
        },
        {
          headerName: "Last Name",
          field: "lastName",
          editable: true,
          sortable: true,
        },
        {
          headerName: "Groups",
          field: "groups",
          valueGetter: (params) => this.getVisibleGroups(params.data?.groups),
          cellRenderer: GroupCellRenderer,
          filter: "agSetColumnFilter",
          comparator: groupComparator,
          filterValueGetter: (params) => {
            return this.getVisibleGroups(params.data?.groups).map((group) => group.name);
          },
        },
        { headerName: "Status", field: "status" },
      ],
    };
    this.props.addTabToNav({
      title: "User Management",
      name: "User Management",
      id: "userManagement",
      type: "userManagement",
      path: "/userManagement",
      icon: "userManagement",
      activeChildren: [],
    });
    this.handleClose = this.handleClose.bind(this);
    this.cellEditStopped = this.cellEditStopped.bind(this);
    this.updateInputValue = this.updateInputValue.bind(this);
    this.onRowSelected = this.onRowSelected.bind(this);
    this.addUser = this.addUser.bind(this);
    this.inviteUsers = _.debounce(this.inviteUsers.bind(this), 1000, {
      leading: true,
      trailing: false,
    });
    this.deleteUsers = _.debounce(this.deleteUsers.bind(this), 1000, {
      leading: true,
      trailing: false,
    });
    this.onGridReady = this.onGridReady.bind(this);
    this.updateGroups = this.updateGroups.bind(this);
    this.showAssignModal = this.showAssignModal.bind(this);
    this.toggleGroupState = this.toggleGroupState.bind(this);
    this.handleSave = this.handleSave.bind(this);

    this.handleInputChange = this.handleInputChange.bind(this);
    this.cellValueChanged = this.cellValueChanged.bind(this);
  }

  componentDidMount() {
    this.unmounted = false;
    this.props.getUsers();
    this.props.getGroups();
  }

  componentWillUnmount() {
    this.unmounted = true;
    this.gridApi = null;
    this.inviteUsers.cancel();
    this.deleteUsers.cancel();
  }

  onInputChange(option) {
    return option.replace(/[\W_]+/g, "");
  }
  componentDidUpdate(prevProps) {
    if (prevProps && (prevProps.userGroups !== this.props.userGroups ||
        prevProps.groupsLoading !== this.props.groupsLoading || prevProps.groupsError !== this.props.groupsError)) {
      const api = this.gridApi;
      if (api && !api.isDestroyed?.()) {
        api.getColumnFilterHandler?.("groups")?.refreshFilterValues?.();
        api.refreshClientSideRowModel?.("filter");
        api.refreshCells?.({ columns: ["groups"], force: true });
      }
    }
    if (!this.props.loading && !this.state.invitedCheckRan) {
      let uninvited = this.props.users.filter((user) => {
        return user.status === "Uninvited";
      });
      if (uninvited.length > 0) {
        this.setState({ invitedCheckRan: true, uninvited: true });
      }
    }
    if (this.props.inviteToastMessage != null) {
      if (this.props.inviteToastMessage.pass) {
        toast.success(this.props.inviteToastMessage.message);
      } else {
        toast.error(this.props.inviteToastMessage.message);
      }
      this.props.clearToasts();
    }
  }

  updateInputValue(evt, source = null) {
    if (source == null) {
      this.setState({
        inputValue: evt.target.value,
      });
    } else {
      this.setState({
        [source]: evt.target.value,
      });
    }
  }

  handleClose() {
    if (this.unmounted) return;
    this.setState({
      showAddUserModal: false,
      showGroupsModal: false,
      inputValue: "",
      userName: "",
      firstName: "",
      lastName: "",
      groups: [],
      showDeleteConfirmModal: false,
      ...((this.groupSaveInFlight || this.state.savingGroups) ? {} : {
        groupStates: {},
        initialGroupStates: {},
        editingUsers: [],
        showAssignGroupsModal: false,
      }),
    });
  }

  clearGridSelection() {
    if (this.unmounted) return;
    try {
      if (this.gridApi && !this.gridApi.isDestroyed?.()) this.gridApi.deselectAll();
    } catch {
      toast.info("Unable to clear the user selection. Refresh the user list before selecting users again.");
    }
  }
  cellEditStopped(event) {
    const { users } = this.props;
    if (event.colDef.field === "lastName") {
      users[event.rowIndex].lastName = event.value;
    } else if (event.colDef.field === "firstName") {
      users[event.rowIndex].firstName = event.value;
    }
  }
  cellValueChanged(item) {
    var user = this.props.searchUsers[item.rowIndex];
    if (item.colDef.field === "firstName") {
      user.firstName = item.newValue;
    } else if (item.colDef.field === "lastName") {
      user.lastName = item.newValue;
    }

    this.props.updateUser(user);
  }

  onRowSelected(event, grid = "") {
    const selected = event.node.isSelected();
    this.setState((prevState) => {
      if (grid === "main") {
        const selectedUsers = prevState.selectedUsers.filter((user) => user.id !== event.data._id);
        if (selected && event.data._id) {
          selectedUsers.push({
            id: event.data._id,
            graphId: event.data.graphId,
            name: event.data.userName,
            groups: [...(event.data.groups || [])],
            status: event.data.status,
          });
        }
        return { selectedUsers };
      }
      const groups = prevState.groups.filter((group) => group !== event.data.id);
      return { groups: selected ? [...groups, event.data.id] : groups };
    });
  }

  addUser() {
    const { userName, lastName, firstName, groups } = this.state;
    if (userName === "") {
      window.alert("You need to specify a User Name");
    } else if (!validator.isEmail(userName)) {
      window.alert("Your User Name is required to be a Email Address");
    } else {
      this.props.addNewUser({
        userName,
        lastName,
        firstName,
        groups,
      });

      this.setState({ invitedCheckRan: false, uninvited: true });
      this.handleClose();
    }
  }
  normalizeGroupIds(groups) {
    if (!groups) return [];
    return groups
      .map((group) => {
        const id = group && typeof group === "object" ? group._id || group.id : group;
        return id == null ? null : id.toString();
      })
      .filter((id) => id !== null);
  }

  getClientGroups() {
    if (this.props.groupsLoading || this.props.groupsError) return [];
    return this.props.userGroups || [];
  }

  getVisibleGroups(groups) {
    const catalogue = new Map(this.getClientGroups().filter(Boolean).map((group) => [String(group._id || group.id), group]));
    return this.normalizeGroupIds(groups).map((id) => catalogue.get(id)).filter(Boolean);
  }

  computeGroupStates(selectedUsers = this.state.selectedUsers) {
    const { userGroups } = this.props;
    const groupStates = {};
    userGroups.forEach((group) => {
      const groupId = group.id.toString();
      const memberCount = selectedUsers.filter((user) => this.normalizeGroupIds(user.groups).includes(groupId)).length;
      if (memberCount === 0) {
        groupStates[groupId] = "unchecked";
      } else if (memberCount === selectedUsers.length) {
        groupStates[groupId] = "checked";
      } else {
        groupStates[groupId] = "indeterminate";
      }
    });
    return groupStates;
  }

  toggleGroupState(groupId) {
    if (this.state.savingGroups) return;
    this.setState((prevState) => {
      const groupStates = { ...prevState.groupStates };
      const current = groupStates[groupId];
      const startedIndeterminate = prevState.initialGroupStates[groupId] === "indeterminate";
      let next;
      if (startedIndeterminate) {
        if (current === "indeterminate") next = "checked";
        else if (current === "checked") next = "unchecked";
        else next = "indeterminate";
      } else {
        next = current === "checked" ? "unchecked" : "checked";
      }
      groupStates[groupId] = next;
      return { groupStates };
    });
  }

  async updateGroups() {
    if (this.unmounted || this.groupSaveInFlight || this.state.savingGroups || this.state.editingUsers.length === 0) return;
    const { groupStates, editingUsers } = this.state;
    let graphUsers = [];
    let nonGraphUsers = [];

    const selectedUsers = editingUsers.map((sUser) => {
      let finalIds = this.normalizeGroupIds(sUser.groups);
      Object.keys(groupStates).forEach((groupId) => {
        const rowState = groupStates[groupId];
        if (rowState === "checked" && !finalIds.includes(groupId)) {
          finalIds = [...finalIds, groupId];
        } else if (rowState === "unchecked") {
          finalIds = finalIds.filter((id) => id !== groupId);
        }
      });
      return { ...sUser, groups: finalIds };
    });

    selectedUsers.forEach((sUser) => {
      if (sUser.status === "Uninvited") {
        nonGraphUsers.push(sUser);
      } else {
        graphUsers.push(sUser);
      }
    });
    this.groupSaveInFlight = true;
    this.setState({ savingGroups: true });
    let saveError;
    try {
      const results = await Promise.allSettled([
        ...(nonGraphUsers.length ? [this.props.updateUserGroups(nonGraphUsers, { refresh: false })] : []),
        ...(graphUsers.length ? [this.props.graphUpdateUserGroups(graphUsers, { refresh: false })] : []),
      ]);
      const refresh = await this.props.getUsers();
      const failed = results.find((result) => result.status === "rejected");
      if (failed) throw failed.reason;
      if (refresh && refresh.type === "FETCH_USERS_FAILURE") throw new Error("Unable to refresh saved users. Please retry.");
    } catch (error) {
      saveError = error || new Error("Unable to update selected users.");
    } finally {
      this.groupSaveInFlight = false;
      if (!this.unmounted) {
        this.setState({
          savingGroups: false,
          showAssignGroupsModal: false,
          editingUsers: [],
          groupStates: {},
          initialGroupStates: {},
          ...(saveError ? {} : { selectedUsers: [] }),
        });
      }
    }
    if (this.unmounted) return;
    if (saveError) {
      const message = saveError?.response?.data?.message || saveError?.message || "Unable to update selected users.";
      toast.error(`${message} Reopen Assign User Groups to review saved memberships before retrying.`);
    } else {
      this.clearGridSelection();
      toast.success("Selected Users updated.");
    }
  }
  deleteUsers() {
    const { selectedUsers } = this.state;

    if (selectedUsers.length > 0) {
      this.props.deleteUsers(selectedUsers);

      this.setState({
        selectedUsers: [],
        invitedCheckRan: false,
        uninvited: false,
      });
      this.handleClose();
    }
  }
  inviteUsers() {
    if (this.state.selectedUsers.length > 0) {
      this.props.inviteSpecifiedUsers(this.state.selectedUsers);
      // toast.success("Specified Users invited.");
    } else {
      this.props.inviteUsers();
      // toast.success("All Users invited.");
    }

    this.setState({ invitedCheckRan: true, uninvited: false });
  }

  addUserModal() {
    const { showAddUserModal } = this.state;
    return (
      <Modal className="user-mgmt-dialog" style={{ height: "80%" }} isOpen={showAddUserModal}>
        <ModalHeader>Add User</ModalHeader>

        <ModalBody>
          <div style={{ display: "flex" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginRight: "8px",
              }}>
              <div className="input-label">Username (email address)</div>
              <input
                ref={this.userName}
                value={this.state.userName}
                onChange={(evt) => this.updateInputValue(evt, "userName")}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginRight: "8px",
              }}>
              <div className="input-label">First Name</div>
              <input
                ref={this.firstName}
                value={this.state.firstName}
                onChange={(evt) => this.updateInputValue(evt, "firstName")}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                overflow: "auto",
              }}>
              <div className="input-label">Last Name</div>
              <input
                ref={this.lastName}
                value={this.state.lastName}
                onChange={(evt) => this.updateInputValue(evt, "lastName")}
              />
            </div>
          </div>
          <div
            style={{
              height: "85%",
              display: "flex",
              flexDirection: "column",
              marginTop: "16px",
            }}>
            <div style={{ marginBottom: "8px" }}>Assign User Groups</div>
            <div style={{ height: "100%", width: "100%" }} className="ag-theme-balham">
              <AgGridReact
                modules={gridModules}
                columnDefs={[
                  {
                    headerName: "Group",
                    field: "name",
                  },
                ]}
                rowData={this.getClientGroups()}
                rowSelection={{
                  mode: "multiRow",
                  checkboxes: true,
                  headerCheckbox: false,
                  enableClickSelection: false,
                }}
                defaultColDef={{ sortable: true, filter: true }}
                onRowSelected={this.onRowSelected}
                onGridReady={(event) => this.onGridReady(event, "groups")}
              />
            </div>
          </div>
        </ModalBody>

        <ModalFooter>
          <Button bsstyle="primary" onClick={this.addUser}>
            Save changes
          </Button>
          <Button onClick={this.handleClose}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  deleteConfirmModal() {
    const { showDeleteConfirmModal } = this.state;
    return (
      <Modal isOpen={showDeleteConfirmModal}>
        <ModalHeader>Delete Users</ModalHeader>

        <ModalBody>
          <div style={{ display: "flex" }}>Are you sure you want to delete the selected user(s)?</div>
        </ModalBody>

        <ModalFooter>
          <Button bsstyle="primary" onClick={this.deleteUsers}>
            Delete
          </Button>
          <Button onClick={this.handleClose}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }

  onGridReady(event, grid = "main") {
    if (grid === "main") this.gridApi = event.api;
    event.api.sizeColumnsToFit();
  }
  showAssignModal(event) {
    if (this.state.savingGroups || this.state.showAssignGroupsModal) return;
    if (this.props.groupsLoading) {
      toast.info("Client groups are still loading. Please wait and try again.");
      return;
    }
    if (this.props.groupsError) {
      toast.error("Unable to load client groups. Refreshing the group list; please try again.");
      this.props.getGroups();
      return;
    }
    if (this.props.loading) {
      toast.info("Users are still loading. Please wait and try again.");
      return;
    }
    if (this.props.usersLoadError) {
      toast.error("Unable to load saved users. Refreshing the user list; please try again.");
      this.props.getUsers();
      return;
    }
    const selectedIds = new Set(this.state.selectedUsers.map((user) => user.id));
    const selectedUsers = [...new Map(this.props.users
      .filter((user) => selectedIds.has(user._id))
      .map((user) => [user._id, user])).values()]
      .map((user) => ({
        id: user._id,
        graphId: user.graphId,
        name: user.userName,
        groups: [...(user.groups || [])],
        status: user.status,
      }));
    if (selectedUsers.length !== selectedIds.size) {
      this.setState({ selectedUsers: [] });
      this.clearGridSelection();
      toast.warn("Some selected users are no longer available. Reselect users before assigning groups.");
      return;
    }
    if (selectedUsers.length >= 1) {
      const groupStates = this.computeGroupStates(selectedUsers);
      this.setState({
        showAssignGroupsModal: true,
        selectedUsers,
        editingUsers: selectedUsers,
        groupStates,
        initialGroupStates: groupStates,
      });
    }
  }

  assignGroupsModal() {
    const { showAssignGroupsModal, groupStates, savingGroups, editingUsers } = this.state;
    const userGroups = this.getClientGroups();
    return (
      <Modal className="user-mgmt-dialog" style={{ height: "80%" }} isOpen={showAssignGroupsModal}>
        <ModalHeader>Assign User Groups</ModalHeader>

        <ModalBody>
          <div className="tri-state-group-list">
            {[...userGroups]
              .sort((a, b) => a.name.localeCompare(b.name, undefined, { sensitivity: "base" }))
              .map((group) => {
                const groupId = group.id.toString();
                const rowState = groupStates[groupId] || "unchecked";
                return (
                  <label
                    key={groupId}
                    className="tri-state-group-row"
                    data-testid={`assign-group-row-${groupId}`}>
                    <input
                      type="checkbox"
                      className="tri-state-checkbox"
                      data-testid={`assign-group-checkbox-${groupId}`}
                      checked={rowState === "checked"}
                      disabled={savingGroups}
                      title={rowState === "indeterminate" ? "Some users have this group selected" : undefined}
                      ref={(el) => {
                        if (el) el.indeterminate = rowState === "indeterminate";
                      }}
                      onChange={() => this.toggleGroupState(groupId)}
                    />
                    <span className="tri-state-group-name">{group.name}</span>
                  </label>
                );
              })}
          </div>
        </ModalBody>

        <ModalFooter>
          <Button bsstyle="primary" onClick={this.updateGroups} disabled={savingGroups || editingUsers.length === 0}>
            Save changes
          </Button>
          <Button onClick={this.handleClose} disabled={savingGroups}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
  addGroupModal() {
    const { showGroupsModal } = this.state;
    return (
      <Modal isOpen={showGroupsModal}>
        <ModalHeader>Add User Group</ModalHeader>

        <ModalBody>
          <input value={this.state.inputValue} onChange={(evt) => this.updateInputValue(evt)} />
        </ModalBody>

        <ModalFooter>
          <Button bsstyle="primary" onClick={this.handleSave}>
            Save changes
          </Button>
          <Button onClick={this.handleClose}>Close</Button>
        </ModalFooter>
      </Modal>
    );
  }
  handleSave() {
    var value = this.state.inputValue;
    axios
      .post(
        `${process.env.REACT_APP_BIGHORN_SERVER}/api/userManagement/addGroup`,
        {
          groupName: value,
          //idToken: localStorage.getItem("id_token")
        },
        {
          headers: {
            //Authorization: "Bearer " + localStorage.getItem("access_token")
            ClientToken: localStorage.getItem("clientToken"),
          },
        },
      )
      .then((response) => {
        toast.success('Group "' + value + '" added.');
        this.props.addUserGroupSuccess(response.data.userGroup);
      })
      .catch((error) => {
        toast.error('Group "' + value + '" Already Exists');
      });

    this.setState({ showGroupsModal: false, inputValue: "" });
  }

  handleInputChange() {
    this.props.filterUsers(this.userSearch.value, this.props.users);
  }

  render() {
    const { searchUsers } = this.props;
    const { uninvited } = this.state;

    return (
      <div data-testid="user-management-page" style={{ display: "flex", height: "74%", width: "77%" }}>
        {this.addUserModal()}
        {this.deleteConfirmModal()}
        {this.assignGroupsModal()}
        {this.addGroupModal()}
        <div style={{ width: "100%" }}>
          <div style={{ height: "100%" }}>
            <div style={{ height: "100%" }} className="ovis-tab-view">
              <div style={{ height: "100%" }}>
                <div className="client" style={{ display: "flex", paddingBottom: "20px" }}>
                  <div className="app-page-title">User Management</div>
                  <div className="spacer" style={{ width: "10%" }} />

                  <div
                    style={{
                      marginLeft: "auto",
                      display: "flex",
                      flexDirection: "row",
                    }}>
                    {uninvited && <div style={{ marginRight: "10px", marginTop: "4px" }}>You have uninvited users:</div>}
                    {!this.props.isInviting ? (
                      <div style={{ marginLeft: "auto" }} className="ta-button ta-button-secondary" onClick={this.inviteUsers}>
                        Invite Users
                      </div>
                    ) : (
                      <div style={{ marginLeft: "auto" }} className="ta-button ta-button-disabled">
                        Inviting
                        <span style={{ color: "white" }} className="dot">
                          .
                        </span>
                        <span className="dot">.</span>
                        <span className="dot">.</span>
                      </div>
                    )}
                  </div>
                </div>
                <div className="user-group-title-div">
                  <input
                    className="input-box"
                    placeholder="search"
                    ref={(input) => (this.userSearch = input)}
                    onChange={this.handleInputChange}
                    style={{ width: "20%", marginTop: "auto" }}
                  />
                  <div style={{ marginLeft: "auto", display: "flex" }}>
                    <div
                      onClick={(event) => {
                        this.setState({ showAddUserModal: true });
                      }}
                      className="ta-button ta-button-primary user-button"
                      style={{ marginLeft: "8px", marginRight: "8px" }}>
                      +Add User
                    </div>

                    <div
                      onClick={(event) => {
                        this.showAssignModal(event);
                      }}
                      className="ta-button ta-button-secondary user-button"
                      style={{ marginRight: "8px" }}>
                      Assign Group
                    </div>

                    <div
                      onClick={(event) => {
                        console.log(this.state.selectedUsers);
                        if (this.state.selectedUsers.length > 0) {
                          this.setState({ showDeleteConfirmModal: true });
                        }
                      }}
                      className="ta-button ta-button-danger user-button"
                      style={{}}>
                      Delete User
                    </div>
                  </div>
                </div>
                <div
                  className="ag-theme-balham"
                  style={{
                    height: "99%",
                    width: "100%",
                  }}>
                  <AgGridReact
                    modules={gridModules}
                    columnDefs={this.state.columnDefs}
                    rowData={searchUsers}
                    onCellEditingStopped={this.cellEditStopped}
                    deltaRowDataMode={false}
                    rowSelection={{
                      mode: "multiRow",
                      checkboxes: true,
                      headerCheckbox: false,
                      enableClickSelection: false,
                    }}
                    defaultColDef={{
                      resizable: true,
                      sortable: true,
                      filter: true,
                      comparator: function (a, b) {
                        if (typeof a === "string") {
                          return a.localeCompare(b);
                        } else {
                          return a > b ? 1 : a < b ? -1 : 0;
                        }
                      },
                    }}
                    getRowId={(params) => {
                      return params.data._id;
                    }}
                    onRowSelected={(event) => {
                      this.onRowSelected(event, "main");
                    }}
                    onCellValueChanged={(event) => {
                      this.cellValueChanged(event);
                    }}
                    components={{ GroupCellRenderer: GroupCellRenderer }}
                    onGridReady={(event) => this.onGridReady(event)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  users: state.userManagementReducer.users,
  usersLoadError: state.userManagementReducer.usersLoadError,
  inviteToastMessage: state.userManagementReducer.inviteToastMessage,
  searchUsers: state.userManagementReducer.searchUsers,
  loading: state.userManagementReducer.loading,
  isInviting: state.userManagementReducer.isInviting,
  userGroups: state.groupReducer.userGroups,
  groupsLoading: state.groupReducer.groupsLoading,
  groupsError: state.groupReducer.groupsLoadError,
});

export const mapDispatchToProps = (dispatch) => ({
  getUsers() {
    return dispatch(getUsers());
  },
  getGroups() {
    dispatch(getGroups());
  },
  addNewUser(client, user) {
    dispatch(addNewUser(client, user));
  },
  addUserToGroup(client, user) {
    dispatch(addUserToGroup(client, user));
  },
  graphUpdateUserGroups(users, options) {
    return dispatch(graphUpdateUserGroups(users, options));
  },
  updateUserGroups(users, options) {
    return dispatch(updateUserGroups(users, options));
  },
  inviteUsers(client) {
    dispatch(inviteUsers(client));
  },
  inviteSpecifiedUsers(client, users) {
    dispatch(inviteSpecifiedUsers(client, users));
  },
  deleteUsers(client, users) {
    dispatch(deleteUsers(client, users));
  },
  addUserGroup(client, groupName) {
    dispatch(addUserGroup(client, groupName));
  },
  filterUsers(filter, users) {
    dispatch(filterUsers(filter, users));
  },
  addUserGroupSuccess(group) {
    dispatch(addUserGroupSuccess(group));
  },
  clearToasts() {
    dispatch(clearToasts());
  },
  addTabToNav(tab) {
    dispatch(addTabToNav(tab));
  },
  updateUser(user) {
    dispatch(updateUser(user));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement);
